import React, { useState } from "react";
import { Modal } from "../../shared/components/modal/Modal";
import CircularProgress from "@material-ui/core/CircularProgress";

/**
 * Modal component for displaying Aurora designs and allowing selection
 * @param {boolean} isOpen - Whether the modal is open
 * @param {Function} onClose - Callback to close the modal
 * @param {Array} designs - Array of design objects from Aurora
 * @param {Function} onSelectDesign - Callback when a design is selected (receives designId, returns Promise)
 * @param {boolean} isLoading - Whether data is being loaded
 */
const AuroraDesignModal = ({
  isOpen,
  onClose,
  designs = [],
  onSelectDesign,
  isLoading = false,
}) => {
  const [syncingDesignId, setSyncingDesignId] = useState(null);

  const handleSelectDesign = async (designId) => {
    if (onSelectDesign) {
      setSyncingDesignId(designId);
      try {
        await onSelectDesign(designId);
        // Close modal after sync completes
        onClose();
      } catch (error) {
        console.error("Error syncing design:", error);
        // Reset syncing state on error but don't close modal
        setSyncingDesignId(null);
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Select Aurora Design"
      className="large"
    >
      <div>
        {isLoading ? (
          <div style={{ textAlign: "center", padding: "2rem" }}>
            <p>Loading designs...</p>
          </div>
        ) : designs.length === 0 ? (
          <div style={{ textAlign: "center", padding: "2rem" }}>
            <p>No designs found for this project.</p>
          </div>
        ) : (
          <div>
            <ul style={{ listStyle: "none", padding: 0 }}>
              {designs.map((design) => (
                <li
                  key={design.id}
                  style={{
                    padding: "1rem",
                    marginBottom: "0.5rem",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h6 style={{ margin: 0, marginBottom: "0.25rem" }}>
                      {design.name || `Design ${design.id}`}
                    </h6>
                    {design.system_size_stc && (
                      <small style={{ color: "#666", display: "block" }}>
                        System Size (STC): {(design.system_size_stc / 1000).toFixed(2)} kW
                      </small>
                    )}
                    {design.system_size_ac && (
                      <small style={{ color: "#666", display: "block" }}>
                        System Size (AC): {(design.system_size_ac / 1000).toFixed(2)} kW
                      </small>
                    )}
                    {design.created_at && (
                      <small style={{ color: "#666", display: "block" }}>
                        Created: {new Date(design.created_at).toLocaleDateString()}
                      </small>
                    )}
                  </div>
                  <button
                    className="btn btn-primary"
                    onClick={() => handleSelectDesign(design.id)}
                    disabled={syncingDesignId !== null}
                  >
                    {syncingDesignId === design.id ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      "Sync with Proposal"
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AuroraDesignModal;

